<template>
  <div class="pb-1">
    <div v-if="filteredData.length > 0">
      <TableComponent :columns="columns" :list="filteredData">
        <template slot="table-row" slot-scope="{ entry, column }">
          <span class="block" v-if="column.field === 'ownership_assigned'">
            {{ entry?.ownership_assigned?.name }}
          </span>
          <span class="block" v-else-if="column.field === 'total_distance_meter'"> {{ entry?.total_distance_meter }}km </span>
          <span class="block" v-else-if="column.field === 'total_income'"> {{ entry.total_income | currencyFormat }} </span>
          <span v-else>{{ entry[column.field] }}</span>
        </template>
      </TableComponent>

      <div class="text-neutral-500 font-medium mt-2 text-sm px-2" v-if="!isMobile">Menampilkan {{ start }} - {{ end }} dari {{ totalRecords }}</div>
      <div class="mt-8 flex justify-center items-center mb-6" v-if="filteredData && filteredData.length > 0">
        <pagination :currentPage="currentPage" :totalCount="totalRecords" :pageSize="pageSize" @onPageChange="onPageChange" />
      </div>
    </div>
    <div class=" flex justify-center items-center py-10" v-else>
      - Data tidak tersedia -
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { currencyFormat } from '@/util'
export default {
  filters: {
    currencyFormat
  },
  components: {
    TableComponent: () => import(/* webpackChunkName: "Table" */ '@/components/Table/Table'),
    Pagination: () => import(/* webpackChunkName: "Pagination" */ '@/components/Pagination/Pagination')
  },
  data() {
    return {
      columns: [
        // { label: 'ID', field: 'id' },
        { label: 'Nama Kendaraan', field: 'vehicle_name' },
        { label: 'Plat Armada', field: 'vehicle_plat_id' },
        { label: 'Aset Owner', field: 'ownership_assigned' },
        { label: 'Total Jarak Tempuh', field: 'total_distance_meter' },
        { label: 'Pendapatan', field: 'total_income' }
      ],
      data: [
        {
          id: '001',
          name: 'Mitsubisi Colt 110PS',
          plat: 'B 2313 TI',
          year: '2018',
          owner: 'Raditya Wira Pratama',
          distance: '133KM',
          income: 'Rp 24.000.000'
        },
        {
          id: '002',
          name: 'Mitsubisi Colt 110PS',
          plat: 'B 2313 TI',
          year: '2018',
          owner: 'Raditya Wira Pratama',
          distance: '133KM',
          income: 'Rp 24.000.000'
        }
      ],
      searchTerm: '',
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      hasMorePages: true
    }
  },
  computed: {
    ...mapGetters('common', ['isMobile']),
    ...mapGetters('armada', ['partnerVehicle']),
    ...mapGetters('auth', ['userData']),
    partnerId() {
      return this.userData?.user?.group_id
    },
    filteredData() {
      let temp = this.partnerVehicle || []
      temp = temp.filter(item => {
        return item.id !== ''
      })
      return temp
    },
    start() {
      return (this.currentPage - 1) * this.pageSize + 1
    },
    end() {
      const lastOnPage = (this.currentPage - 1) * this.pageSize + this.pageSize
      return lastOnPage > this.totalRecords ? this.totalRecords : lastOnPage
    }
  },
  created() {
    this.getVehicleList()
  },
  methods: {
    ...mapActions('common', ['showLoading', 'hideLoading']),
    ...mapActions('armada', ['getPartnerVehicle']),
    getVehicleList() {
      this.showLoading()
      this.getPartnerVehicle({
        partnerId: this.partnerId,
        vehiclePartnerId: this.$route.params.id,
        params: {
          page: this.currentPage,
          per_page: this.pageSize,
          search_keyword: '',
          sort: 'DESC'
        }
      })
        .then(res => {
          this.totalRecords = res.data.meta.total_item
          this.hideLoading()
        })
        .catch(() => {
          this.hideLoading()
        })
    },
    onPageChange(page) {
      this.currentPage = page
    }
  }
}
</script>
